var technologyInformation = {
  technologies: [
    {
      name: "Flutter",
      description:
        "The new cross plattform development technology from Google. It uses the Dart language and allows you to build native apps for Android and iOS from a single code base.",
      selected: false,
      value: "flutter",
      available: true
    },
    {
      name: "React Native",
      description:
        "React Native lets you build mobile apps using only JavaScript. It uses the same design as React, letting you compose a rich mobile UI using declarative components.",
      selected: false,
      value: "react",
      available: false
    },
    {
      name: "Ionic",
      description:
        "Ionic Framework is the free, open source mobile UI toolkit for developing high-quality cross-platform apps for native iOS, Android, and the web—all from a single codebase.",
      selected: false,
      value: "ionic",
      available: false
    }
  ]
};

exports.technologyInfo = technologyInformation;